import { SHOW_COMMEMORATE } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const WidgetBylines = ({ eventDataLayer, article }) => {
  const bylines = (article?.bylineList ?? []).map(item => String(item?.p_name ?? '').trim()).filter(name => name !== '');

  return (
    <>
      <WidgetWrapper gray={SHOW_COMMEMORATE === 'true'} id='byline-wrapper'>
        {bylines.length > 0 ? (
          <>
            <div className='title-byline'> By </div>
            {bylines.map((name, index) => (
              <div className='flex-end' key={index}>
                <a href={`/bylines/${encodeURIComponent(name)}`} aria-label={`ดูบทความของ ${name}`} onClick={() => sendDataLayerGlobal({ ...eventDataLayer, section: `นามปากกา:${name}` })}>
                  <p className='by-line'>{name}</p>
                </a>
              </div>
            ))}
          </>
        ) : (
          <>
            <div className='title-byline'> By </div>
            <div className='flex-end'>
              <a href={'/bylines/กรุงเทพธุรกิจ'} onClick={() => sendDataLayerGlobal({ ...eventDataLayer, section: 'นามปากกา:กรุงเทพธุรกิจ' })} aria-label={'ดูบทความของ กรุงเทพธุรกิจ'}>
                <p className='by-line'>{'กรุงเทพธุรกิจ'}</p>
              </a>
            </div>
          </>
        )}
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0px 0 16px;
  filter: ${props => (props.gray ? 'grayscale(0.7)' : 'none')};
  .title-byline {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7e7e7e;
    font-size: 20px;
    margin: 0 10px 0px 0;
  }
  .flex-end {
    display: flex;
    justify-content: end;
  }
  p.by-line {
    cursor: pointer;
    color: #373636;
    background: #c8c8c8;
    padding: 3px 10px;
    margin-right: 10px;
    border-radius: 0 10px;
    :hover {
      background: #d2def2;
    }
  }
  a.by-line {
    cursor: pointer;
    color: #373636;
    background: #c8c8c8;
    padding: 3px 10px;
    margin-left: 10px;
    border-radius: 0 10px;
    :hover {
      background: #d2def2;
    }
  }
  @media (max-width: 767px) {
    display: block;
    flex-wrap: wrap;
    .by-line {
      margin-bottom: 5px;
      text-align: end;
      width: fit-content;
    }
  }
  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 0 10px;
    p.by-line,
    a.by-line {
      margin: 0 5px;
    }
    .title-byline {
      margin: 0 5px 0 0;
    }
  }
`;
export default WidgetBylines;
